import { render, staticRenderFns } from "./RowThirdParty.vue?vue&type=template&id=067373c9&scoped=true&"
import script from "./RowThirdParty.vue?vue&type=script&lang=js&"
export * from "./RowThirdParty.vue?vue&type=script&lang=js&"
import style0 from "./RowThirdParty.vue?vue&type=style&index=0&id=067373c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067373c9",
  null
  
)

export default component.exports